import RegisterComponent from '@components/register';
import * as React from 'react';

export interface IRegisterProps {}

export default function Register(props: IRegisterProps) {
  return <RegisterComponent />;
}
